import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=c2e3b964&scoped=true"
import script from "./CustomerData.vue?vue&type=script&lang=js"
export * from "./CustomerData.vue?vue&type=script&lang=js"
import style0 from "./CustomerData.vue?vue&type=style&index=0&id=c2e3b964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e3b964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
